import RequestManager from "../../../requests/RequestManager";
import keyAktSeedTask from "../../../requests/tasks/sports/keyAktSeedTask";
import PlaybackTask from "../../../requests/tasks/sports/playbackTask";
import { transformBase64 } from "../../../utils/Utils";
import { getIsMundial2026, getPlaybackAktSeedConfig } from '../../../containers/Mundial2026/utils';
import ChannelSingleton from "../../../components/Epg/ChannelsSingleton";
import EpgLineUpV1 from "../../../requests/tasks/epg/EpgLineUpV1";
import LocalStorage from "../../../components/DeviceStorage/LocalStorage";
import logger from 'src/utils/logger/logger';

const getChannelData = async (groupId) => {
    const filters = await new ChannelSingleton().getFilters()
    const nodeId = (filters && filters[0] && filters[0].id)
        ?  filters[0].id
        : null

    if (nodeId) {
        const lineupParams = {
            node_id: nodeId,
            epg_version: LocalStorage.getItem('epgVersion') || false,
        };
        const lineupTaks = new EpgLineUpV1(lineupParams)
        const lineupResponse = await RequestManager.addRequest(lineupTaks)
        const channels = lineupResponse && lineupResponse.response && lineupResponse.response.channels
        const channelData = channels && channels.find(item => item.group_id === groupId)
        return channelData
    }

    return null
}

const getClientIp = async (url) => {
    const seedTask = new keyAktSeedTask(url);
    const seedResponse = await RequestManager.addRequest(seedTask);

    const clientIpMatch = seedResponse.match(/<clientip>([^<]+)<\/clientip>/);
    // Validamos que existan antes de extraer el valor (posición [1] del match)
    const clientIp = clientIpMatch ? clientIpMatch[1] : null;

    return clientIp ? transformBase64(clientIp) : null;
}

const getkeyAktSeed = async (groupId, defaultClientIpUrl) => {
    const channelData = await getChannelData(groupId);

    const protectedPlay = (
        channelData &&
        channelData.group &&
        channelData.group.common &&
        channelData.group.common.extendedcommon &&
        channelData.group.common.extendedcommon.media &&
        channelData.group.common.extendedcommon.media.language &&
        channelData.group.common.extendedcommon.media.language.options &&
        channelData.group.common.extendedcommon.media.language.options.option &&
        channelData.group.common.extendedcommon.media.language.options.option[0] &&
        channelData.group.common.extendedcommon.media.language.options.option[0].protected_play &&
        channelData.group.common.extendedcommon.media.language.options.option[0].protected_play.dashwv) || null;

    const clientIpUrl = protectedPlay || defaultClientIpUrl;

    try {
        return await getClientIp(clientIpUrl);
    } catch (error) {
        logger.error('Error getting seed client IP header:', error);

        // Si falló la URL protegida, intentamos con la URL por defecto
        if (protectedPlay && protectedPlay !== defaultClientIpUrl && defaultClientIpUrl) {
            try {
                return await getClientIp(defaultClientIpUrl);
            } catch (error) {
                logger.error('Fallback client IP request failed:', error);
                return null
            }
        }
        return null;
    }
};

export const getPlayBackData = async (leagueId, matchId, miniplayerRetryConfig, versionPlayBackConfig, playComments = true, groupId = null) => {
    try {
        // Obtener configuración de seed desde metadata
        const playbackAktSeedConfig = getPlaybackAktSeedConfig();
        const isEnabledPlaybackAktSeed = (playbackAktSeedConfig && playbackAktSeedConfig.enabled) || false
        const defaultClientIpUrl = (playbackAktSeedConfig && playbackAktSeedConfig.client_ip_fallback_url) || null

        // Ejecutar petición al seed solo si está habilitado
        const keyAktSeed = isEnabledPlaybackAktSeed ? await getkeyAktSeed(groupId, defaultClientIpUrl) : null;

        // Crear tarea de reproducción con el header de IP si está disponible
        const playbackTask = new PlaybackTask(
            leagueId,
            matchId,
            miniplayerRetryConfig,
            versionPlayBackConfig,
            "es-ES",
            playComments,
            keyAktSeed
        );

        const response = await RequestManager.addRequest(playbackTask);
        if (!response) return [];
        logger.debug('Playback data response:', response);
        return response.response;
    } catch (error) {
        logger.error('Error getting playback data:', error);
        return { playback: [], tabs: [] };
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/getPlayBack.js